<template>
<div class ="tips2" >
      <div class="weui-msg box2" ref="scorll">
        <!-- <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div> -->
        <div class="weui-msg__text-area" >
            <h2 class="weui-msg__title">调查问卷</h2>
            <div style="text-align: left;">
              
              <div class="weui-cells weui-cells_checkbox">
                  <div class="weui-cells__title" style="font-size: 16px;font-weight: bold;color:#000;">1.请问您了解中药伴侣吗？</div>
                  <label class="weui-cell weui-check__label" for="x11">
                      <div class="weui-cell__bd">
                          <p>A 了解</p>
                      </div>
                      <div class="weui-cell__ft">
                          <input class="weui-check" name="first" v-model="anser.first" id="x11" type="radio" value="了解">
                          <span class="weui-icon-checked"></span>
                      </div>
                  </label>
                  <label class="weui-cell weui-check__label" for="x12">
                      <div class="weui-cell__bd">
                          <p>B 一般</p>
                      </div>
                      <div class="weui-cell__ft">
                          <input name="first" v-model="anser.first" class="weui-check" id="x12" type="radio" value="一般">
                          <span class="weui-icon-checked"></span>
                      </div>
                  </label>
                  <label class="weui-cell weui-check__label" for="x13">
                      <div class="weui-cell__bd">
                          <p>C 不了解</p>
                      </div>
                      <div class="weui-cell__ft">
                          <input name="first" v-model="anser.first" class="weui-check" id="x13" type="radio" value="不了解">
                          <span class="weui-icon-checked"></span>
                      </div>
                  </label>
              </div>
              
              <div class="weui-cell">
                <div class="weui-cell__hd">
                    <label class="weui-label" style="margin-top: 25px;">2.就诊医生</label>
                </div>
                <div class="weui-cell__bd">
                    <input class="weui-input" placeholder="请输入医生姓名" type="text" style="padding-left:30px;margin-top: 25px;border-bottom: 2px solid #000;" v-model="anser.second">
                </div>
              </div>
              <div class="weui-cells weui-cells_checkbox">
                <div class="weui-cells__title" style="font-size: 16px;font-weight: bold;color:#000;">3.本次就医感受？</div>
                  <label class="weui-cell weui-check__label" for="x31">
                      <div class="weui-cell__bd">
                          <p>A 非常满意</p>
                      </div>
                      <div class="weui-cell__ft">
                          <input class="weui-check" name="third" v-model="anser.third" id="x31" type="radio" value="非常满意">
                          <span class="weui-icon-checked"></span>
                      </div>
                  </label>
                  <label class="weui-cell weui-check__label" for="x32">
                      <div class="weui-cell__bd">
                          <p>B 满意</p>
                      </div>
                      <div class="weui-cell__ft">
                          <input name="third" v-model="anser.third" class="weui-check" id="x32" type="radio" value="满意">
                          <span class="weui-icon-checked"></span>
                      </div>
                  </label>
                  <label class="weui-cell weui-check__label" for="x33">
                      <div class="weui-cell__bd">
                          <p>C 一般</p>
                      </div>
                      <div class="weui-cell__ft">
                          <input name="third" v-model="anser.third" class="weui-check" id="x33" type="radio" value="一般">
                          <span class="weui-icon-checked"></span>
                      </div>
                  </label>
              </div>
            </div>
        </div>
        <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
                <a href="javascript:;" class="weui-btn weui-btn_primary" @click="submitInfo">提 交</a>
            </p>
        </div>
        <div class="weui-msg__extra-area">

        </div>
    </div>
	<div class="tpis-mask"></div>
	</div>
</template>

<script>
// import BScroll from 'better-scroll'
export default {
	name: 'Tips2',
  	data () {
	    return { 
        Scroll:{},
        anser:{
          first: '',
          second: '',
          third: ''
        }
	    }
	},
  // mounted() {
  //     this.$nextTick(() => {
  //       //$refs绑定元素
  //       if(!this.Scroll){
  //           this.Scroll = new BScroll(this.$refs.scorll, {
  //           //开启点击事件 默认为false
  //           click:true,
  //           scrollY: true,
  //       })
  //       // console.log(this.scroll)
  //       }else if(!this.$refs.scorll){
  //           return
  //       }
  //       else{
  //           this.Scroll.refresh()
  //       }
  //     })
  // },
	methods: {
    submitInfo(){
      //const info = '1'+this.anser.first+'<br/>2'+this.anser.second+'<br/>3'+this.anser.third
      //alert(info);
      this.$emit("answerInfo",this.anser)
    }
	}
      
}

</script>


<style>
@import url('../../common/css/style.css');
@import url('../../common/css/weui.css');
@import url('../../common/css/weuix.css');
.tips2{
  text-align:center;
 
}
.tips2 .box2{
  position: fixed;
  z-index: 200;
  width:90%;
  height:90%;
  overflow: scroll;
  top:5%;
  left:5%;
  font-size:16px;
  background-color:#fff;
}

.tips2 .tpis-mask{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 198;
	background: rgba(7,17,27,0.6);
}


</style>


// WEBPACK FOOTER //
// src/components/questionnaire/Questionnaire.vue